import React from 'react'
import ProductItem from './search/ProductItem';
import fetcher from '../API';
import _ from 'lodash';

class SimilarProducts extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            products: []
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        fetcher.get(`/api/v2/products/${id}/similar/context/PRODUCT_DETAILS`, null, {
                'Content-Type': 'application/x-protobuf-json',
            }).then(response=>{
            this.setState({
                products: response.data.products
            })
        }).catch(error=>{

        });
    }

    renderProductItem() {
        const {products} = this.state;
        return _.map(products, (product) => {
            return (<ProductItem product={product.product} key={product.product.id}/>);
        });
    }


    render() {
        const productItems = this.renderProductItem();
        const productItemsContainer = (
            <div className="container-fluid mt-3">
                <div className="row">
                    {productItems}
                </div>
            </div>
        );
        return (
            <div className='container-fluid bg-light pt-3'>
                {productItemsContainer}
            </div>
        );
    }
}

export default SimilarProducts;